module.exports = __WEBPACK_EXTERNAL_MODULE__portfolio_main_content_8201bfa5__;